// Port de app/(tabs)/biometria.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const BiometriaScreen = lazy(() => import("@/screens/Biometria"));

export default function BiometriaRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <BiometriaScreen />
    </Carregando>
  ) : null;
}
